import React from 'react';
import { isEqual } from 'lodash';
import EventAllList from '../EventAllList';
import './EventAllListWrap.scss';

const EventInProgressListWrap = (props) => {
  const {
    allEvent,
    getList,
    getExcelDownload,
    openEventItemListModal,
    setInitialAllEventList,
    getEventTagColumnTagList,
  } = props;
  const { allEventList, originalAllEventList } = allEvent;

  return (
    <div className="event-all-list-wrap">
      {/*전체 기획전 리스트*/}
      <EventAllList
        allEventList={allEventList}
        originalAllEventList={originalAllEventList}
        isUpdateList={!isEqual(allEventList.list, originalAllEventList)}
        getList={getList}
        getExcelDownload={getExcelDownload}
        openEventItemListModal={openEventItemListModal}
        setInitialAllEventList={setInitialAllEventList}
        getEventTagColumnTagList={getEventTagColumnTagList}
      />
    </div>
  );
};

export default EventInProgressListWrap;
